module.exports = __webpack_public_path__ + "img/jagopack-active.c01051c9.svg";